import { render } from "./SideBarRight.vue?vue&type=template&id=6fea19ea&scoped=true"
import script from "./SideBarRight.vue?vue&type=script&lang=js"
export * from "./SideBarRight.vue?vue&type=script&lang=js"

import "./SideBarRight.vue?vue&type=style&index=0&id=6fea19ea&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fea19ea"]])

export default __exports__